(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      /* 搜索聚焦时，禁止 header hide */
      if (document.activeElement?.classList.contains('search__input')) {
       this.currentScrollTop = scrollTop;
       return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

   
  }

  customElements.define('sticky-header', StickyHeader);
  
  (function () {
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const inlineMenu = document.querySelector('.header__inline-menu');
  const drawerToggle = document.querySelector(
    'summary[aria-controls="menu-drawer"]'
  );

  /* ------------------------------
   * 移动端：抽屉菜单关闭
   * ------------------------------ */
  document.addEventListener('click', (e) => {
    if (
      e.target.closest('.mobile-nav-close') &&
      drawerToggle
    ) {
      drawerToggle.click();
    }
  });

  /* ------------------------------
   * 桌面端：hover 下拉菜单
   * ------------------------------ */
  if (!inlineMenu) return;

  const items = inlineMenu.querySelectorAll('details');
  let hoverTimer;

  const openItem = (current) => {
    items.forEach((item) => {
      if (item !== current) item.removeAttribute('open');
    });
    current.setAttribute('open', '');
  };

  const closeItem = (item, delay = 150) => {
    hoverTimer = setTimeout(() => {
      item.removeAttribute('open');
    }, delay);
  };

  items.forEach((item) => {
    const submenu = item.querySelector('ul');

    item.addEventListener('mouseenter', () => {
      if (!DESKTOP.matches) return;
      clearTimeout(hoverTimer);
      openItem(item);
    });

    item.addEventListener('mouseleave', () => {
      if (!DESKTOP.matches) return;
      closeItem(item);
    });

    submenu?.addEventListener('mouseenter', () => {
      if (!DESKTOP.matches) return;
      clearTimeout(hoverTimer);
      openItem(item);
    });

    submenu?.addEventListener('mouseleave', () => {
      if (!DESKTOP.matches) return;
      closeItem(item, 100);
    });
  });

  /* ------------------------------
   * ESC / 点击空白 关闭（桌面）
   * ------------------------------ */
  document.addEventListener('click', (e) => {
    if (!DESKTOP.matches) return;
    if (!e.target.closest('.header__inline-menu')) {
      items.forEach((item) => item.removeAttribute('open'));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (!DESKTOP.matches) return;
    if (e.key === 'Escape') {
      items.forEach((item) => item.removeAttribute('open'));
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
